var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowDownHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowDownHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1543.000000, -36.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(1184.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(168.200000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-83",
    transform: "translate(41.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.382424,24.3511732 C151.637373,24.6178625 151.970546,24.7512071 152.303718,24.7512071 C152.63689,24.7512071 152.971511,24.6178473 153.225012,24.3511732 L156.617576,20.802402 C156.862385,20.5463045 157,20.1993053 157,19.8386686 C157,19.4765318 156.862385,19.1295175 156.617576,18.8749504 L153.297441,15.3988975 C152.788991,14.8670342 151.963303,14.8670342 151.453404,15.3988975 C150.944954,15.9307609 150.944954,16.7944706 151.453404,17.3278493 L153.852245,19.8371533 L151.382424,22.4222063 C150.872525,22.9556001 150.872525,23.8178097 151.382424,24.3511732 Z",
    id: "icArrowDownHeader",
    transform: "translate(154.000000, 19.875604) scale(1, -1) rotate(-90.000000) translate(-154.000000, -19.875604) "
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownHeader);
export default __webpack_public_path__ + "static/media/icArrowDownHeader.7ea506d21221065803336a621009065a.svg";
export { ForwardRef as ReactComponent };